import type { AxiosRequestConfig } from 'axios';

import { httpClient } from './http-client';

export const createService = (servicePath: string) => ({
  get: <Data>(url: string, config?: AxiosRequestConfig) =>
    httpClient.get<Data>(`${servicePath}${url}`, config),
  post: <Data>(url: string, body?: unknown, config?: AxiosRequestConfig) =>
    httpClient.post<Data>(`${servicePath}${url}`, body, config),
  put: <Data>(url: string, body?: unknown, config?: AxiosRequestConfig) =>
    httpClient.put<Data>(`${servicePath}${url}`, body, config),
  patch: <Data>(url: string, body?: unknown, config?: AxiosRequestConfig) =>
    httpClient.patch<Data>(`${servicePath}${url}`, body, config),
  delete: <Data>(url: string, config?: AxiosRequestConfig) =>
    httpClient.delete<Data>(`${servicePath}${url}`, config),
});
